import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { programsQuery } from '../constants/queries';
import { CustomButton } from '../components/UI/CustomButton';
import { MdEdit } from 'react-icons/md';
import { JSX } from 'react';
import { useToastContext } from '../components/UI/ToastManager';
import dateFormatHelper from '../utils/dateFormat';

export type ProgramsQueryResponse = {
  programs: {
    id: string;
    name: string;
    status: string;
    constraints: {
      gender: string[];
      sport: string[];
      userLevel: string[];
      category: string[];
      material: string[];
      specialProgram: string[];
      pathology: string[];
      weekFocus: string[];
    };
    lastUpdateDate: Date;
  }[];
};

export type ProgramsTableItem = {
  id: string;
  name: string;
  status: string;
  gender: string;
  sport: string;
  userLevel: string;
  category: string;
  material: string;
  specialProgram: string;
  date: string;
  actions: JSX.Element;
};

export function useProgramsQuery() {
  const { showError } = useToastContext();

  return useQuery<ProgramsTableItem[]>({
    queryKey: ['programs'],
    queryFn: () =>
      graphqlRequest<ProgramsQueryResponse>(programsQuery, undefined, showError).then(({ programs }) =>
        programs.map((program): ProgramsTableItem => ({
          id: program.id,
          name: program.name,
          status: program.status,
          gender: program.constraints.gender?.join(', ') || '',
          sport: program.constraints.sport?.join(', ') || '',
          userLevel: program.constraints.userLevel?.join(', ') || '',
          category: program.constraints.category?.join(', ') || '',
          material: program.constraints.material?.join(', ') || '',
          specialProgram: program.constraints.specialProgram?.join(', ') || '',
          date: dateFormatHelper(program.lastUpdateDate),
          actions: (
            <CustomButton visual="ghost" justifyContent="flex-start">
              <MdEdit />
            </CustomButton>
          ),
        }))
      ),
  });
}